import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';
import { ButtonReset } from '../../layout/reset';
import { Wrapper as Notification } from '../Notification/wrapper';

export const Wrapper = styled.div`
  --_tabs-gap: ${size(0.5)};
  --_tabs-group-gap: calc(var(--_tabs-gap) + ${size(1)});

  position: relative;
  width: 100%;
  min-width: 0; // Make it work in a flexbox context
`;

export const ListOverflowHidden = styled.div`
  overflow: hidden;
`;

export const List = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: var(--_tabs-group-gap);
  overflow: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Group = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: var(--_tabs-gap);

  & + & {
    border-left: 1px solid var(--c-border-main);
    padding-left: var(--_tabs-group-gap);
  }
`;

interface TabProps {
  $isActive?: boolean;
}

export const Tab = styled(ButtonReset)<TabProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${size(1)};
  padding: ${size(0.5)} ${size(1.5)};
  background-color: var(--_tab-bg, var(--c-tabs-bg));
  border-radius: ${size(1.5)};
  color: var(--_tab-fg, var(--c-tabs-fg));
  font-size: ${(props) => props.theme.font.size.small};
  line-height: ${(props) => props.theme.font.size.xxlarge};
  font-weight: var(--font-weight-medium);
  user-select: none;
  white-space: nowrap;

  ${({ $isActive }) =>
    $isActive
      ? css`
          --_tab-bg: var(--c-tabs-active-bg);
          --_tab-fg: var(--c-tabs-active-fg);
        `
      : css`
          &:hover {
            --_tab-bg: var(--c-tabs-hover-bg);
          }
        `}

    ${Notification} {
      margin-block: -50%;
    }
`;

/* Scroll Buttons */

interface ScrollButtonProps {
  $isVisible: boolean;
}

const ScrollButton = styled.div<ScrollButtonProps>`
  opacity: ${(props) => (props.$isVisible ? 1 : 0)};
  pointer-events: ${(props) => (props.$isVisible ? 'all' : 'none')};
  position: absolute;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  isolation: isolate;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background-color: var(--c-bg-main);
    z-index: -1;
  }

`;

export const ScrollButtonStart = styled(ScrollButton)`
  left: 0;

  &::before {
    mask-image: ${(props) => props.theme.mask.gradient.toRight};
  }
`;

export const ScrollButtonEnd = styled(ScrollButton)`
  right: 0;

  &::before {
    mask-image: ${(props) => props.theme.mask.gradient.toLeft};
  }
`;

export const ScrollButtonBtn = styled(ButtonReset)`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: ${size(5)};
  height: ${size(5)};
  border-radius: 50%;
  background-color: white;
  border: 1px solid var(--c-border-main);
  user-select: none;
  transform-origin: 50% 50%;
  transition: transform 200ms ease;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    box-shadow: ${(props) => props.theme.boxshadow.large};
    border-radius: inherit;
    opacity: 0;
    transition: opacity 200ms ease;
  }

  &:enabled {
    &:active {
      transform: scale(0.95);
    }

    &:hover {
      &::before {
        opacity: 1;
      }
    }
  }

  &[disabled] {
    opacity: 0.37;
    cursor: not-allowed;
  }
`;
